import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Heart, Share2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const sessionId = () => {
  let id = localStorage.getItem('eventism_reader_session');
  if (!id) {
    id = `rs_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem('eventism_reader_session', id);
  }
  return id;
};

export const GuideEngagementBar = ({ city, slug, title }) => {
  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!city || !slug) return;
    axios.get(`${API}/public/guides/${city}/${slug}/engagement`, { params: { session_id: sessionId() } })
      .then((res) => { setLikes(res.data.like_count); setLiked(res.data.liked); })
      .catch(() => {});
  }, [city, slug]);

  const toggleLike = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await axios.post(`${API}/public/guides/${city}/${slug}/like`, { session_id: sessionId() });
      setLiked(res.data.liked);
      setLikes(res.data.like_count);
    } catch {
      toast.error('Could not save your like — try again');
    } finally {
      setBusy(false);
    }
  };

  const share = async () => {
    const url = `${window.location.origin}/${city}/guides/${slug}`;
    const track = () => axios.post(`${API}/public/guides/${city}/${slug}/share`).catch(() => {});
    if (navigator.share) {
      try { await navigator.share({ title, url }); track(); } catch { /* user cancelled */ }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      track();
      toast.success('Link copied — share it anywhere');
    } catch {
      toast.error('Could not copy the link');
    }
  };

  return (
    <div className="flex items-center gap-2 mt-5" data-testid="guide-engagement-bar">
      <Button
        variant="outline"
        size="sm"
        onClick={toggleLike}
        className={`rounded-full gap-1.5 transition-colors ${liked ? 'border-rose-500/50 bg-rose-500/10 text-rose-400 hover:bg-rose-500/20 hover:text-rose-400' : 'hover:text-rose-400'}`}
        data-testid="guide-like-button"
        aria-pressed={liked}
      >
        <Heart className={`h-4 w-4 ${liked ? 'fill-rose-500 text-rose-500' : ''}`} />
        {liked ? 'Liked' : 'Like'}
        <span className="font-semibold" data-testid="guide-like-count">{likes}</span>
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={share}
        className="rounded-full gap-1.5 hover:text-indigo-400"
        data-testid="guide-share-button"
      >
        <Share2 className="h-4 w-4" /> Share
      </Button>
    </div>
  );
};

export default GuideEngagementBar;
